<template>
  <div id="schedule_statistics">
    <div class="select_row_box">
      <SelectItem
        v-for="selectItem in selectList"
        :key="selectItem.state"
        :options="selectItem"
        :curVal="selectItem.curVal"
        @changeValEvent="selectChangeVal"
      ></SelectItem>
    </div>
    <div class="group_container" ref="tableParentDom">
      <div
        v-show="groupDatas && groupDatas.length > 0"
        class="group_box"
        v-for="(group, groupIndex) in groupDatas"
        :key="group.key"
      >
        <span class="teamName" v-text="teamInforArr[groupIndex]"></span>
        <div class="table_container">
          <nodeTree_table
            :currThemeObj="currThemeObj"
            :currCid="currCid"
            :currSid="currSid"
            :tableMode="tableMode"
            :parentWidthPx="parentWidthPx"
            :isScrollFlag="isScrollFlag"
            :isClickFlag="isClickFlag"
            :variableColWidthVw="variableColWidthVw"
            :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
            :defaultWidthVwNum="defaultWidthVwNum"
            :tableColumnData="tableColumnData"
            :tableData="group.tableData"
            :tableHeightPx="0"
            :jumpRouterPathNames="jumpRouterPathNames"
            :cellClassName="cellClassName"
            :arraySpanMethod="arraySpanMethod"
            :tableCustomCellRender="tableCustomCellRender"
            valFormatReturnDefaultVal="- -"
            :unClickDetailMode="unClickDetailMode"
            v-show="group.tableData && group.tableData.length > 0"
          ></nodeTree_table>
          <span
            class="noDataClass"
            v-show="group.tableData && group.tableData.length == 0"
          >
            暂无数据
          </span>
        </div>
      </div>
      <cup_notData
        v-show="groupDatas && groupDatas.length === 0"
        className="relativePtb60"
      ></cup_notData>
    </div>
  </div>
</template>
<script>
import { https_matchDetail_teamStatData } from '@api/platfrom_basketball_api'

import SelectItem from '@components/platfromBase/basketball/selectItem.vue'
import nodeTree_table from '@components/platfromBase/marathon/nodeTree_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import platfrom_refresh_data_mixin from '@mixins/platfrom_refresh_data'
import cup_notData from '@components/base/NO_DATA.vue'

export default {
  name: 'schedule_statistics',
  components: { SelectItem, nodeTree_table, cup_notData },
  mixins: [cup_base_data_mixin, platfrom_refresh_data_mixin],
  props: {
    matchInfor: {
      type: Object,
      default: () => ({
        leagueName: '',
        gameDateWeb: '',
        matchStatus: '',
        homeWinLoss: '',
        awayWinLoss: '',
        homeId: '',
        homeTeam: '',
        homeTeamPoints: '-',
        homeTeamLogo: '',
        awayId: '',
        awayTeam: '',
        awayTeamPoints: '-',
        awayTeamLogo: '',
      }),
    },
  },
  data() {
    return {
      loading: false,
      tableMode: 'teamData',
      jumpRouterPathNames: {
        pathName_teamDetail: 'teamDetailIndex',
        pathName_playerDetail: 'playerDetailIndex',
      },
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: true,
      isClickFlag: false,
      variableColWidthVw: 6,
      tableCellDefaultWidthVw: 4.25,
      defaultWidthVwNum: null,
      tableColumnData: [],
      groupDatas: null,
      tableCustomCellRender: {
        props: ['fieldGoals', 'freeThrows', 'threePoints', 'twoPoints'],
        classNames: [
          'flexCloCenter',
          'flexCloCenter',
          'flexCloCenter',
          'flexCloCenter',
        ],
      },
      selectList: [
        {
          list: [
            {
              id: '1',
              name: '基础数据',
            },
            {
              id: '2',
              name: '高阶数据',
            },
          ],
          keyValArr: ['id', 'name'],
          placeholder: '请选择',
          isFilterable: false,
          widthVw: 9.74,
          curVal: '',
          state: 'dataType',
        },
        // {
        //   list: [],
        //   keyValArr: ['sectionId', 'sectionName'],
        //   placeholder: '请选择',
        //   isFilterable: false,
        //   widthVw: 9.74,
        //   curVal: '',
        //   state: 'sectionType',
        // },
      ],
      curSelect_dataType: '1',
      // curSelect_sectionType: '',
    }
  },
  created() {
    if (this.currThemeObj) {
      const moduleRouteNameEn = this.currThemeObj.moduleRouteNameEn
      this.jumpRouterPathNames = {
        pathName_teamDetail: `teamDetailIndex_${moduleRouteNameEn}`,
        pathName_playerDetail: `playerDetailIndex_${moduleRouteNameEn}`,
      }
    }
    this.query = this.$route.query
    this.init()
  },
  mounted() {
    this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
    console.debug('this.parentWidthPx:', this.$refs.tableParentDom.scrollHeight)
  },
  computed: {
    teamInforArr() {
      return [this.matchInfor.homeTeam, this.matchInfor.awayTeam]
    },
    unClickDetailMode() {
      console.debug('this.currThemeObj:', this.currThemeObj)
      let flag = false
      if (['FIBAWA', 'FIBAMA'].includes(this.currThemeObj.moduleRouteNameEn)) {
        flag = true //不可点击进入详情
      }
      return flag
    },
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      setTimeout(() => {
        this.initSelectOpt()
      }, 100)
      await this.getTeamStatData()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    initSelectOpt() {
      let selectList = JSON.parse(JSON.stringify(this.selectList))
      this.selectList = selectList.map((item) => {
        if (item) {
          item.curVal = this[`curSelect_${item.state}`]
        }
        return item
      })
    },
    selectChangeVal(data) {
      console.debug('selectChangeVal:', data)
      if (data.state === 'dataType') {
        this.curSelect_dataType = data.val
      }
      console.debug(this.curSelect_dataType, this.curSelect_sectionType)
      this.getTeamStatData()
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      let className = ''
      if (row.isPlay === 0 && columnIndex == 1) {
        className = 'unPlayRow'
      } else {
        this.tableCustomCellRender.props.forEach((cellItem) => {
          if (column.property === cellItem) {
            className = 'cell_clo2Row'
          }
        })
      }
      return className
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (row.isPlay === 0) {
        if (columnIndex === 1) {
          return [1, 16]
        } else if (columnIndex > 1) {
          return [0, 0]
        }
      }
    },
    async refreshCallback() {
      await this.getTeamStatData()
    },
    async getTeamStatData() {
      await https_matchDetail_teamStatData(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        phid: this.curSelect_dataType,
        mid: this.query.mid,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (res.data && res.data.length > 0) {
              this.groupDatas = res.data.map((group, groupInd) => {
                let tableData = []
                if (group && group.middle) {
                  const leftColumns = group.left
                  const middleColumns = group.middle
                  const rightColumns = group.right
                  // const fristColumns_left = leftColumns.slice(0, 3)
                  // const otherColumns_left = leftColumns.slice(3)
                  this.defaultWidthVwNum = group.middle.length
                  if (this.tableColumnData.length == 0) {
                    let tableColumnData = []
                    let leftColumnObjArr = []
                    let rightColumnObjArr = []
                    for (let i = 0; i < leftColumns.length; i++) {
                      leftColumnObjArr.push({
                        prop: 'leftPlayerName', //fristColumnPropArr.join('-'),
                        label: '球员',
                        widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                        className: 'columnTeamNameClass', //单独定制的头部样式class
                        fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
                      })
                    }

                    tableColumnData = [].concat(leftColumnObjArr)
                    for (let i = 0; i < middleColumns.length; i++) {
                      const item = middleColumns[i]
                      tableColumnData.push({
                        prop: item.colKey,
                        label: item.colTitle,
                        widthVw: this.tableCellDefaultWidthVw, //对应列的宽度，单位vw
                        className: '', //单独定制的头部样式class
                        selected: item.selected,
                      })
                    }

                    for (let i = 0; i < rightColumns.length; i++) {
                      // rightColumnObjArr.push({
                      //   prop: 'leftTeamName', //fristColumnPropArr.join('-'),
                      //   label: '球队',
                      //   widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                      //   className: 'columnTeamNameClass', //单独定制的头部样式class
                      //   fixed: 'right', //是否锁定，如果开启不滚动，此字段无效
                      // })
                    }

                    this.tableColumnData = [].concat(
                      tableColumnData,
                      rightColumnObjArr
                    )
                  }
                } else {
                  console.debug('暂无数据')
                }
                tableData = group.datas
                  ? group.datas.map((rowItem, rowItemIndex) => {
                      if (
                        rowItemIndex === group.datas.length - 1 &&
                        !rowItem[group.middle[0].colKey]
                      ) {
                        rowItem[group.middle[0].colKey] = '- -'
                      } else if (
                        rowItem.isPlay === 0 &&
                        group.middle &&
                        group.middle.length > 0
                      ) {
                        rowItem[group.middle[0].colKey] = '未上场'
                      } else {
                        rowItem[group.middle[0].colKey] = `#${
                          rowItem[group.middle[0].colKey]
                        }`
                      }
                      this.tableCustomCellRender.props.forEach((cellItem) => {
                        if (rowItem[cellItem]) {
                          const arr =
                            rowItem[cellItem].indexOf(',') > -1
                              ? rowItem[cellItem].split(',')
                              : []
                          if (arr.length === 3) {
                            rowItem[`${cellItem}_web`] = [
                              `${arr[0]}-${arr[1]}`,
                              arr[2],
                            ]
                          } else {
                            rowItem[`${cellItem}_web`] = ['-', '-']
                          }
                        }
                      })
                      return rowItem
                    })
                  : []
                console.debug('this.tableData:', tableData)
                return {
                  key: groupInd == 0 ? 'home' : 'away',
                  tableData,
                }
              })
              console.debug('groupDatas:', this.groupDatas)
              if (
                this.isRefresh &&
                this.refreshCallbackHandle &&
                !this.setIntervalId
              ) {
                this.refreshCallbackHandle(this.refreshCallback)
              }
            } else {
              this.groupDatas = []
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
#schedule_statistics {
  .select_row_box {
    padding-top: 2.778vw;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    & > div {
      margin-right: 0.694vw;
    }
  }
  .group_container {
    width: 100%;
    .group_box {
      padding: 1.388vw 0 2.778vw 0;
      .teamName {
        display: block;
        padding-bottom: 0.974vw;
        font-size: 1.25vw;
        font-weight: bold;
      }
    }

    .noDataClass {
      display: block;
      width: 100%;
      line-height: 5.55vw;
      text-align: center;
      font-size: 0.972vw;
      color: var(--mixtmt_greyColor2);
    }
    .noDataClass {
      border-top: 1px solid var(--mixtmt_greyColor0);
      border-bottom: 1px solid var(--mixtmt_greyColor0);
    }
  }
}
</style>
